const ApiError = ({ message = '', code = '' }) => ({
  name: 'ApiError',
  message,
  code,
});

ApiError.prototype = Error.prototype;

export default ApiError;
